"use client";

import * as SelectPrimitive from "@radix-ui/react-select";

const SelectRoot = SelectPrimitive.Root;
const SelectTrigger = SelectPrimitive.SelectTrigger;
const SelectValue = SelectPrimitive.SelectValue;
const SelectIcon = SelectPrimitive.SelectIcon;
const SelectPortal = SelectPrimitive.SelectPortal;
const SelectContent = SelectPrimitive.SelectContent;
const SelectViewport = SelectPrimitive.SelectViewport;
const SelectGroup = SelectPrimitive.SelectGroup;
const SelectLabel = SelectPrimitive.SelectLabel;
const SelectItem = SelectPrimitive.SelectItem;
const SelectItemText = SelectPrimitive.SelectItemText;
const SelectItemIndicator = SelectPrimitive.SelectItemIndicator;
const SelectScrollUpButton = SelectPrimitive.SelectScrollUpButton;
const SelectScrollDownButton = SelectPrimitive.SelectScrollDownButton;
const SelectSeparator = SelectPrimitive.SelectSeparator;
const SelectArrow = SelectPrimitive.SelectArrow;

type SelectProps = SelectPrimitive.SelectProps;
type SelectTriggerProps = SelectPrimitive.SelectTriggerProps;
type SelectValueProps = SelectPrimitive.SelectValueProps;
type SelectIconProps = SelectPrimitive.SelectIconProps;
type SelectPortalProps = SelectPrimitive.SelectPortalProps;
type SelectContentProps = SelectPrimitive.SelectContentProps;
type SelectViewportProps = SelectPrimitive.SelectViewportProps;
type SelectGroupProps = SelectPrimitive.SelectGroupProps;
type SelectLabelProps = SelectPrimitive.SelectLabelProps;
type SelectItemProps = SelectPrimitive.SelectItemProps;
type SelectItemTextProps = SelectPrimitive.SelectItemTextProps;
type SelectItemIndicatorProps = SelectPrimitive.SelectItemIndicatorProps;
type SelectScrollUpButtonProps = SelectPrimitive.SelectScrollUpButtonProps;
type SelectScrollDownButtonProps = SelectPrimitive.SelectScrollDownButtonProps;
type SelectSeparatorProps = SelectPrimitive.SelectSeparatorProps;
type SelectArrowProps = SelectPrimitive.SelectArrowProps;

export {
  SelectArrow,
  SelectContent,
  SelectGroup,
  SelectIcon,
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  SelectLabel,
  SelectPortal,
  SelectRoot,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  SelectViewport,
};

export type {
  SelectArrowProps,
  SelectContentProps,
  SelectGroupProps,
  SelectIconProps,
  SelectItemIndicatorProps,
  SelectItemProps,
  SelectItemTextProps,
  SelectLabelProps,
  SelectPortalProps,
  SelectProps,
  SelectScrollDownButtonProps,
  SelectScrollUpButtonProps,
  SelectSeparatorProps,
  SelectTriggerProps,
  SelectValueProps,
  SelectViewportProps,
};
